"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInternalSettings = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const snackbar_context_1 = require("../../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../../composite/snackbar/snackbar-types");
const error_utils_1 = require("../../utils/error-utils");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const internal_settings_api_1 = require("./internal-settings-api");
function useInternalSettings(url) {
    const intl = (0, react_intl_1.useIntl)();
    const { showSnackbar } = (0, react_1.useContext)(snackbar_context_1.SnackbarContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [settingGroups, setSettingGroups] = (0, react_1.useState)([]);
    const loadInternalSettings = (0, event_callback_hook_1.useEventCallback)(async () => {
        try {
            setLoading(true);
            const response = await (0, internal_settings_api_1.fetchInternalSettings)(url).response;
            let settings;
            try {
                const json = await response.json();
                settings = json;
            }
            catch {
                settings = [];
            }
            setSettingGroups(settings);
            setLoading(false);
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const errorDetail = (0, error_utils_1.getErrorMessage)(err);
                const message = intl.formatMessage({
                    id: 'EAS_INTERNAL_SETTINGS_MSG_LOAD_ERROR',
                    defaultMessage: 'Chyba načtení nastavení: {detail}',
                }, { detail: errorDetail });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw err;
            }
            throw err;
        }
    });
    const saveInternalSettings = (0, event_callback_hook_1.useEventCallback)(async (settingGroups) => {
        const flattenSettings = (0, lodash_1.flatten)(settingGroups.map((group) => { var _a; return (_a = group.settings) !== null && _a !== void 0 ? _a : []; }));
        try {
            const data = await (0, internal_settings_api_1.updateInternalSettings)(url, flattenSettings).json();
            setSettingGroups(data);
            const message = intl.formatMessage({
                id: 'EAS_INTERNAL_SETTINGS_MSG_SAVE_SUCCES',
                defaultMessage: 'Nastavení aplikace bylo úspěšně změněno.',
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
            setLoading(false);
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const errorDetail = (0, error_utils_1.getErrorMessage)(err);
                const message = intl.formatMessage({
                    id: 'EAS_INTERNAL_SETTINGS_MSG_SAVE_ERROR',
                    defaultMessage: 'Chyba uložení nastavení: {detail}',
                }, { detail: errorDetail });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw err;
            }
            throw err;
        }
    });
    const context = (0, react_1.useMemo)(() => ({
        loadInternalSettings,
        saveInternalSettings,
        settingGroups,
        loading,
    }), [loadInternalSettings, saveInternalSettings, settingGroups, loading]);
    return {
        context,
    };
}
exports.useInternalSettings = useInternalSettings;
//# sourceMappingURL=internal-settings-hook.js.map